import { render, staticRenderFns } from "./redirect.vue?vue&type=template&id=07836bf3&"
import script from "./redirect.vue?vue&type=script&lang=js&"
export * from "./redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports